<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
    >
      <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap"></div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template>
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="删除"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-delete"
            circle
            type="success"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <upDataFormPackaging
      ref="upDataFormPackaging"
      :editFormDefaulteArr="editFormDefaulteArr"
      @editUpData="editItemMsg"
      :title="title"
    ></upDataFormPackaging>
  </div>
</template>

<script>
import tablePackaging from '@/components/tablePackaging';
import upDataFormPackaging from '@/components/upDataFormPackaging';
import { clone } from '@/utils/utils';
import {
  categoryCreate,
  categoryDelete,
  categoryQuery,
  categoryUpdate,
} from '@/api/visaCategory';
import { countryGetAll } from '@/api/country';
const defaultEditFormDefaulteArr = [
  {
    fieldName: 'categoryName', //字段
    type: 'input', //类型
    name: '分类名称', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
  {
    fieldName: 'countryBid', //字段
    type: 'select', //类型
    name: '分类所属的国家', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
    selectList: [],
    selectValue: 'countryName', //名字
    selectId: 'countryBid', //list中的需要发给后台的id
  },
];

const defaultSearchObj = {
  pageNum: 1,
  pageSize: 10,
  categoryName: '',
  countryBid: '',
};
export default {
  data() {
    return {
      title: '新建分类',
      searchObj: clone(defaultSearchObj),
      postList: [],
      isOperate: true,
      searchFormList: [
        {
          lable: '分类名称', //请输入 + lable
          searchItem: 'categoryName', //字段名
          type: 'input', //输入框类型
          value: '', //默认值
        },
        {
          lable: '所属国家', //请输入 + lable
          searchItem: 'countryBid', //字段名
          type: 'select', //输入选择框
          selectList: [], //下拉框列表
          selectValue: 'countryName', //名字
          selectId: 'countryBid', //发送后台的内容名字或id
          value: '', //默认值
        },
      ],

      editFormDefaulteArr: clone(defaultEditFormDefaulteArr),
      tableOption: [
        {
          prop: 'categoryName',
          label: '签证分类',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          prop: 'countryName',
          label: '所属国家',
          overHidden: true,
          //sortable: 'name',
        },
      ],
      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
      categoryBid: '',
    };
  },
  mounted() {
    this.getTableData();
    this.getAllCountryList();
  },
  methods: {
    handelClickAdd() {
      this.title = '新建分类';
      this.editFormDefaulteArr.forEach((item) => {
        item.value = '';
      });
      this.categoryBid = '';
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    getAllCountryList() {
      countryGetAll().then((res) => {
        if (res.code == 200) {
          this.searchFormList[1].selectList =
            this.editFormDefaulteArr[1].selectList = res.data;
        }
      });
    },
    getTableData(serData) {
      console.log(serData);
      if (serData) {
        Object.assign(this.searchObj, serData);
      }
      categoryQuery(this.searchObj).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.searchObj.pageNum = obj.pageNum;
      this.searchObj.pageSize = obj.pageSize;
      this.getTableData();
    },
    //修改
    handelClickEdit(row) {
      this.title = '修改分类';
      this.categoryBid = row.categoryBid;
      this.editFormDefaulteArr.forEach((item) => {
        for (var key in row) {
          if (key == item.fieldName) {
            item.value = row[key];
          }
        }
      });
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    editItemMsg(data) {
      if (!this.categoryBid) {
        //新建
        categoryCreate(data)
          .then((res) => {
            console.log(res);
            if (res.code == '200') {
              this.$refs.upDataFormPackaging.closeDialog();
              this.$msg.success('新建成功！');
              this.getTableData();
            }
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
          })
          .catch(() => {
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
            this.$msg.error(res.msg);
          });
      } else {
        //编辑
        data.categoryBid = this.categoryBid;
        categoryUpdate(data)
          .then((res) => {
            if (res.code == '200') {
              this.$refs.upDataFormPackaging.closeDialog();
              this.$msg.success('修改成功！');
              this.getTableData();
            }
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
          })
          .catch(() => {
            this.$refs.upDataFormPackaging.upDataMsg = '保存';
            this.$msg.error(res.msg);
          });
      }
    },
    //删除
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该分类？',
        })
        .then(() => {
          categoryDelete(row.categoryBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    tablePackaging,
    upDataFormPackaging,
  },
};
</script>

<style>
</style>